import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import firebaseConfig from "./firebaseConfig.js";
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
    // Persist offline writes across page reloads to prevent "saved then disappeared" behavior.
    localCache: persistentLocalCache({}),
});
export { app, auth, db };
